export const openCalendar = () => {
	const toggle = document.querySelector("esc-hotel-travel-data-toggle");

	if (toggle) {
		const calendar = document.querySelector(
			".travel-data-editor esc-calendar-input",
		);

		const callback = () => {
			calendar.showDialog();
			toggle.removeEventListener("transitionend", callback);
		};
		toggle.addEventListener("transitionend", callback);
		toggle.open();
	} else {
		const calendar = document.querySelector(
			"esc-availability-calendar-input > esc-calendar-input",
		);
		calendar.showDialog();
	}
};
